import { getGreeting } from "@gettactic/helpers/src/date-time/getGreeting";
import React from "react";

interface DashboardGreetingProps {
  name: string;
  subtitle?: React.ReactNode;
}

export const DashboardGreeting: React.FC<DashboardGreetingProps> = ({
  name,
  subtitle
}) => {
  const firstName = name?.split(" ")[0] || "";

  return (
    <div className="flex w-full flex-col gap-1">
      <div
        className="v2-header-1 text-neutral-1000"
        style={{ fontSize: "32px" }}
      >
        {getGreeting()}, {firstName}
      </div>
      {subtitle && (
        <div className="text-neutral-500 w-full flex items-center">
          <div>{subtitle}</div>
        </div>
      )}
    </div>
  );
};
